import { useNavigate } from "react-router-dom";
import WrapperEmpty from "../wrapper/wrapper-empty";

const ProfileModeration = () => {
    const navigate = useNavigate();

    return (
        <WrapperEmpty>
            <svg
                className="w-16 h-16 mx-auto mb-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m5.25 2A8.25 8.25 0 1112 3.75 8.25 8.25 0 0120.25 12z"
                />
            </svg>
            <h3 className="text-xl font-semibold mb-2">Профиль на модерации</h3>
            <p className="text-gray-600 mb-6">
                Мы проверяем анкету и фото. После одобрения откроются разделы Поиск, Свои и запись на мероприятия.
            </p>
            <div className="space-y-3">
                <button
                    type="button"
                    onClick={() => navigate('/profile/photos')}
                    className="btn-link w-full"
                >
                    Мои фото
                </button>
                <button
                    type="button"
                    onClick={() => navigate('/events')}
                    className="btn-link btn-link-cancel w-full"
                >
                    К событиям
                </button>
            </div>
        </WrapperEmpty>
    );
};

export default ProfileModeration;
